import React, { Suspense, useContext } from 'react';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import { FunnelContext } from '@bbkFunnelComponents/FunnelContext';

const DesignElementEditor = React.lazy(
  () => import('@bbkFunnelComponents/design-element/design-element-editor')
);

type Props = React.ComponentProps<typeof DesignElementEditor>;
const DesignElement: ReactFCC<Props> = (props) => {
  const { children } = props;
  const { isDesigner } = useContext(FunnelContext);

  return isDesigner ? (
    <Suspense
      // Keep section anchors mounted while their editing controls load, so
      // direct-linked Section order can discover the complete preview.
      fallback={
        props.name === 'Plea' || props.name === 'Warning'
          ? children
          : 'Loading...'
      }
    >
      <DesignElementEditor {...props} />
    </Suspense>
  ) : (
    children
  );
};

export default DesignElement;
